import { ViewPlugin } from '@codemirror/view';
import { termsStore } from '../../stores/termsStore.js';

/**
 * CodeMirror extension for detecting clicks on claims and updating the focused claim number
 * This enables the "Focus" view filter in the Terms Panel
 */

export const claimClickDetection = ViewPlugin.fromClass(class {
    constructor(view) {
        this.view = view;
        this.handleClick = this.handleClick.bind(this);
        view.dom.addEventListener('click', this.handleClick);
    }
    
    handleClick(event) {
        // Get the position in the document where the click occurred
        const pos = this.view.posAtCoords({ x: event.clientX, y: event.clientY });
        if (pos === null) return;
        
        // Get the line at this position
        const line = this.view.state.doc.lineAt(pos);
        const lineText = line.text;
        
        // Check if this line starts with a claim number
        const claimNumberMatch = lineText.match(/^\s*(\d+)\./);
        if (claimNumberMatch) {
            const claimNumber = parseInt(claimNumberMatch[1]);
            console.log(`[ClaimClickDetection] Clicked on claim ${claimNumber}`);
            
            // Update the focused claim in the terms store
            termsStore.setFocusedClaim(claimNumber);
        } else {
            // If not on a main claim line, find the preceding main claim number
            let currentLineNumber = line.number;
            let foundClaimNumber = null;
            
            // Search backwards from current line to find the last claim number
            while (currentLineNumber > 1 && foundClaimNumber === null) {
                currentLineNumber--;
                const searchLine = this.view.state.doc.line(currentLineNumber);
                const searchLineText = searchLine.text;
                
                const precedingClaimMatch = searchLineText.match(/^\s*(\d+)\./);
                if (precedingClaimMatch) {
                    foundClaimNumber = parseInt(precedingClaimMatch[1]);
                    break;
                }
            }
            
            if (foundClaimNumber !== null) {
                console.log(`[ClaimClickDetection] Clicked on subclaim section, setting focus to claim ${foundClaimNumber}`);
                termsStore.setFocusedClaim(foundClaimNumber);
            }
        }
    }
    
    destroy() {
        this.view.dom.removeEventListener('click', this.handleClick);
    }
});

/**
 * Extension factory function
 */
export function createClaimClickDetection() {
    return claimClickDetection;
}